// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BaseColumn{width:100%}@media (min-width: 800px){.BaseColumn{padding-left:1rem;padding-right:1rem}}@media (min-width: 800px){.BaseColumn--1\\/2{width:50%}}@media (min-width: 800px){.BaseColumn--1\\/3{width:33.333333%}}@media (min-width: 800px){.BaseColumn--1\\/4{width:25%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
